import React, {useEffect, useState} from 'react'
import useLocalization from './useLocalization'
import toBaseLocale from '../utils/toBaseLocale'
import {LocalizationData} from '../types'

type State =
  | {
      currentLocale: {locale: string; localeLabel: string}
      translations: {locale: string; localeLabel: string; url: string}[]
    }
  | undefined

type Actions = {
  onChangeLocale: LocalizationData['onChangeLocale']
}
const usePageTranslations = (): [State, Actions] => {
  const {currentLocale, localeLabels, translations = [], onChangeLocale} = useLocalization()
  const [data, setData] = useState<State>()

  useEffect(() => {
    if (currentLocale) {
      const switcherData = {
        currentLocale: {
          locale: toBaseLocale(currentLocale),
          localeLabel: localeLabels[currentLocale],
        },
        translations: translations.map(t => ({
          locale: toBaseLocale(t.locale),
          localeLabel: localeLabels[t.locale],
          url: t.url,
        })),
      }
      setData(switcherData)
    }
  }, [currentLocale, translations])

  return [data, {onChangeLocale}]
}

export default usePageTranslations
